/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Why_People_BidInputs */

const en_directory_vibebids_why_people_bid = /** @type {(inputs: Directory_Vibebids_Why_People_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why people bid`)
};

const zh_directory_vibebids_why_people_bid = /** @type {(inputs: Directory_Vibebids_Why_People_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么有人出价`)
};

/**
* | output |
* | --- |
* | "Why people bid" |
*
* @param {Directory_Vibebids_Why_People_BidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_why_people_bid = /** @type {((inputs?: Directory_Vibebids_Why_People_BidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Why_People_BidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_why_people_bid(inputs)
	return zh_directory_vibebids_why_people_bid(inputs)
});
export { directory_vibebids_why_people_bid as "directory.vibebids.why_people_bid" }